import MapImageLayer from '@arcgis/core/layers/MapImageLayer';

/**
 * Create and return a new map image layer instance from a service url.
 * https://developers.arcgis.com/javascript/latest/api-reference/esri-layers-MapImageLayer.html
 * @param {String} url - GIS map image service url
 */
const createMapImageLayer = async ({ url, ...props }) => {
  const { apiKey } = props;

  const requestUrl = apiKey ? (url += `?token=${apiKey}`) : url;

  const layer = new MapImageLayer({
    ...props,
    url: requestUrl,
  });

  await layer.load();

  return layer;
};

export default createMapImageLayer;
